/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import SportSectionOtt from '@dtvgo/sport-section';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import useImageCard from '../../hooks/useImageCard';
import { ImageRatio } from '../../utils/constants';

/* Styles */
import './SportSection.scss';

function SportSection({
  focused,
  className,
  item: collection,
  onMouseDown,
  onMouseEnter,
}) {
  const { title, cardImages } = collection;
  const { imageUrl } = useImageCard({
    images: cardImages,
    imageSize: 300,
    aspectRatio: ImageRatio.ONE_BY_ONE,
  });

  return (
    <SportSectionOtt
      className={
        `dtv-html5-c-sport-section ${focused ? 'dtv-html5-c-sport-section--focused' : ''
        } ${className}`
      }
      imageUrl={imageUrl}
      title={title}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    />
  );
}

SportSection.propTypes = {
  focused: PropTypes.bool.isRequired,
  className: PropTypes.string,
  item: PropTypes.shape().isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

SportSection.defaultProps = {
  className: '',
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

export default memo(withInteractiveFocusable()(memo(SportSection)));
